module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "imagep"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "32",
      "src": "images/stara.jpg",
      "width": "109"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('p', {
    staticClass: "chtitle",
    attrs: {
      "id": "rch06"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('span')]), _c('a', {
    attrs: {
      "href": "#/Contents#ch06"
    }
  }, [_vm._v("EQUIPMENT")])]), _vm._v(" "), _c('p', {
    staticClass: "normalta"
  }, [_c('span', [_vm._v("Although there are plenty of bodyweight movements in this book, some of the exercises require equipment and are demonstrated with military gear. The following is a list of equipment utilized in each section. If you do not have the suggested equipment, simply use one of the recommended substitutions. For example, some of the Core & Stability Exercises require a canteen. If you don’t have a canteen, swap in a medicine ball.")])]), _vm._v(" "), _c('p', {
    staticClass: "normalt"
  }, [_c('span', [_c('span', {
    staticClass: "colora"
  }, [_c('b', [_vm._v("WARM-UP EXERCISES:")])]), _vm._v(" No equipment required for this section.")])]), _vm._v(" "), _c('p', {
    staticClass: "normalt"
  }, [_c('span', [_c('span', {
    staticClass: "colora"
  }, [_c('b', [_vm._v("BALANCE & STABILITY EXERCISES:")])]), _vm._v(" No equipment required for this section, but the usage of dumbbells is optional.")])]), _vm._v(" "), _c('p', {
    staticClass: "normaltb"
  }, [_c('span', [_c('span', {
    staticClass: "colora"
  }, [_c('b', [_vm._v("CORE & STABILITY EXERCISES:")])]), _vm._v(" Both the military helmet and canteen are utilized in this section.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_c('span', {
    staticClass: "colora"
  }, [_c('b', [_vm._v("Military Helmet Substitutions:")])]), _vm._v(" medicine ball, basketball, 10- to 15-pound dumbbell, 10- to 25-pound weight plate, 10- to 20-pound kettlebell")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_c('span', {
    staticClass: "colora"
  }, [_c('b', [_vm._v("Canteen Substitutions:")])]), _vm._v(" medicine ball, 10- to 15-pound dumbbell, 10- to 25-pound weight plate, 10- to 20-pound kettlebell")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-tb"
  }, [_c('span', [_c('span', {
    staticClass: "colora"
  }, [_c('b', [_vm._v("STRENGTH-TRAINING EXERCISES:")])]), _vm._v(" This section utilizes the military helmet, body armor vest, combat uniform and sandbag.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_c('span', {
    staticClass: "colora"
  }, [_c('b', [_vm._v("Military Helmet Substitutions:")])]), _vm._v(" medicine ball, basketball, 10- to 15-pound dumbbell, 10- to 25-pound weight plate, 10- to 20-pound kettlebell")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_c('span', {
    staticClass: "colora"
  }, [_c('b', [_vm._v("Body Armor Vest Substitutions:")])]), _vm._v(" weight vest, medicine ball, 10- to 15-pound dumbbell, 10- to 25-pound weight plate, 10- to 20-pound kettlebell")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_c('span', {
    staticClass: "colora"
  }, [_c('b', [_vm._v("Combat Uniform Substitutions:")])]), _vm._v(" towel, rope, bed sheet")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_c('span', {
    staticClass: "colora"
  }, [_c('b', [_vm._v("Sandbag Substitutions:")])]), _vm._v(" medicine ball, dumbbells, weight plates, kettlebells")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-tb"
  }, [_c('span', [_c('span', {
    staticClass: "colora"
  }, [_c('b', [_vm._v("PUSH-UP SERIES:")])]), _vm._v(" This section utilizes the military helmet.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_c('span', {
    staticClass: "colora"
  }, [_c('b', [_vm._v("Military Helmet Substitutions:")])]), _vm._v(" medicine ball, textbooks, basketball, football")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-tb"
  }, [_c('span', [_c('span', {
    staticClass: "colora"
  }, [_c('b', [_vm._v("AGILITY, SPEED & PLYOMETRIC EXERCISES:")])]), _vm._v(" This section utilizes the military helmet and combat uniform.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_c('span', {
    staticClass: "colora"
  }, [_c('b', [_vm._v("Combat Uniform Substitutions:")])]), _vm._v(" towel, rope, bed sheet, cones")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_c('span', {
    staticClass: "colora"
  }, [_c('b', [_vm._v("Military Helmet Substitutions:")])]), _vm._v(" medicine ball, textbooks")])]), _vm._v(" "), _c('p', {
    staticClass: "normalt"
  }, [_c('span', [_c('span', {
    staticClass: "colora"
  }, [_c('b', [_vm._v("MARTIAL ARTS CARDIO EXERCISES:")])]), _vm._v(" No equipment required for this section, but the usage of dumbbells is optional.")])]), _vm._v(" "), _c('p', {
    staticClass: "normaltb"
  }, [_c('span', [_c('span', {
    staticClass: "colora"
  }, [_c('b', [_vm._v("FLEXIBILITY EXERCISES:")])]), _vm._v(" This section utilizes the combat uniform.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_c('span', {
    staticClass: "colora"
  }, [_c('b', [_vm._v("Combat Uniform Substitutions:")])]), _vm._v(" towel, rope, bed sheet")])]), _vm._v(" "), _c('p', {
    staticClass: "imagez"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "Substitute equipment",
      "height": "140",
      "src": "images/p14.jpg",
      "width": "603"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('i', [_vm._v("Substitute equipment (left to right): Medicine ball, kettlebell, weight plate, basketball")])])])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5adfa61e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter06.vue
// module id = 90
// module chunks = 0